import styled from 'styled-components'

export const DatLabelText = styled.span`
  flex: 1 1 38%;
  min-width: 0;
  font-size: 0.74rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1.35;
  color: rgba(226, 232, 240, 0.8);
  user-select: none;

  @media (max-width: 520px) {
    flex: 1 0 100%;
  }
`
